import { Then } from "./Then";
import { Else } from "@componentsShared/Conditional/Else";
/**
 * Conditional wrapper with Then/Else blocks
 * @example
 * <Conditional condition={isPremium}>
 *   <Then><PremiumContent /></Then>
 *   <Else><FreeContent /></Else>
 * </Conditional>
 */
export var Conditional = function Conditional(_ref) {
  var condition = _ref.condition,
    children = _ref.children;
  var childrenArray = Array.isArray(children) ? children : [children];
  var thenChild = childrenArray.find(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === Then;
  });
  var elseChild = childrenArray.find(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === Else;
  });
  return condition ? thenChild : elseChild;
};